// extracted by mini-css-extract-plugin
export default {"Accordian":"accordian_Accordian__g6i92","Title":"accordian_Title__1cYMi","Content":"accordian_Content__NnaHS"};